// Copyright (c) Jonathan Ferraz.
// Licensed under the MIT license.

import { ReactNode } from 'react';

import { Card } from './styles';

export type CardBlurType = {
  children: ReactNode;
  fullWidth?: boolean;
  bgColor?: string;
  borderColor?: string;
  blur?: number;
  borderRadius?: number;
  shadow?: string;
};

export const CardBlur = (props: CardBlurType) => {
  return <Card {...props}>{props.children}</Card>;
};
